import { createContext } from 'react';

export const IframeRefContext = createContext(null);
